module.exports = __webpack_public_path__ + "48fd2e84aacee2b693d5f180d57c8a27.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-gem-s.png
// module id = 1939
// module chunks = 0